import { CircularProgress, Grid, Stack, Typography } from "@mui/material";
import React, { PropsWithChildren } from "react";

interface IvrUserSkillsConfigCardProps {
  isLoading: boolean;
  title: string;
  subheader?: string;
}

const IvrUserSkillsConfigCard: React.FC<PropsWithChildren<IvrUserSkillsConfigCardProps>> = ({
  isLoading,
  title,
  subheader,
  children
}) => {
  return (
    <Grid container direction="column" sx={{ height: "100%" }} wrap="nowrap" spacing={2}>
      <Grid item>
        <Stack direction="row" justifyContent="space-between" alignItems="end">
          <Typography variant="h5" component="span">
            {title}
          </Typography>
          {subheader && <Typography variant="body2">{subheader}</Typography>}
        </Stack>
      </Grid>
      <Grid item xs sx={{ overflow: "auto" }}>
        {isLoading ? (
          <Grid className="h-100" container justifyContent="center" alignItems="center">
            <CircularProgress />
          </Grid>
        ) : (
          children
        )}
      </Grid>
    </Grid>
  );
};

export default IvrUserSkillsConfigCard;
